import React, { ReactNode, useMemo } from "react";
import { minutes, MouseEventCallbacks } from "../utils/types";

export const CalendarItem: React.FC<{
  duration: minutes;
  expansionDimension: 'width' | 'height';
  slotSize: number;
  className: string;
  children?: ReactNode;
  callbacks?: MouseEventCallbacks;
}> = ({ 
  duration, 
  slotSize, 
  className, 
  children, 
  callbacks = {}, 
  expansionDimension 
}) => {
  const style = useMemo<React.CSSProperties>(() => {
    const size = Math.max(
      (100.0 * duration) / slotSize,
      50
    );
    return { top: 0, [expansionDimension]: `${size}%`}
  }, [duration, slotSize, expansionDimension]);

  return (
    <div className={className} style={style} {...callbacks}>
      {children}
    </div>
  );
};